// extracted by mini-css-extract-plugin
export default {"wrapper":"helpDocuments_wrapper__gWAGy","teamViewer":"helpDocuments_teamViewer__AQjOF","itemWrapper":"helpDocuments_itemWrapper__xbuwC"};